import React, { useEffect, useState } from "react";
import { Box, Card, TextField, Typography, CardContent, Grid, Divider } from "@material-ui/core";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import TabHeader from "src/components/TabHeader/TabHeader";
import { HeadQuarterRoute } from "../../head-quarter.routes";
import { useStyles } from "./components/style";
import Backdrop from "@material-ui/core/Backdrop";
import CommonButton from "src/components/CommonButton/CommonButton";
import { useFormik } from "formik";
import { object, string } from "yup";
import {
  getHQSettings,
  createHQSettings,
  updateHQSettings,
} from "src/app-redux/hq-dashboard/actions/hqDashboardActions";
import { loader } from "src/app-redux/hq-dashboard/hqDashboardSlice";
import CommonLoader from "src/components/Loader/CommonLoader";

type Props = {};
interface Setting {
  id: number;
  cameraFeed: string;
}

export function Settings({}: Props): React.ReactElement {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const loading = useAppSelector(loader);
  const moduleName = HeadQuarterRoute.title;
  const pageHeading = "Settings";
  const [hqSettings, setHQSettings] = useState<Setting>({ id: 0, cameraFeed: "" });

  const validationSchema = object().shape({
    cameraFeed: string().max(200, "Maximum 200 characters allowed"),
  });

  const formik = useFormik<any>({
    enableReinitialize: true,
    initialValues: {
      cameraFeed: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any, actions) => {
      let res;
      const body: any = await {
        cameraFeed: values.cameraFeed,
      };
      if (hqSettings.id == 0) {
        res = await dispatch(createHQSettings(body));
      } else {
        body.id = hqSettings.id;
        res = await dispatch(updateHQSettings(body));
      }
      await resetForm();
      getHQSettingsHandler();
      if (res.payload) {
        actions.setSubmitting(false);
        return;
      }
    },
  });

  const resetForm = () => {
    formik.resetForm();
  };

  const fieldValueHandler = async (setting: any) => {
    formik.setFieldValue("cameraFeed", setting.cameraFeed || "");
    return;
  };

  const getHQSettingsHandler = async () => {
    try {
      const res = await dispatch(getHQSettings());
      if (res.payload) {
        fieldValueHandler(res.payload);
        setHQSettings(res.payload);
        return;
      }
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    getHQSettingsHandler();
  }, []);

  return (
    <>
      <Box m={2} />
      <TabHeader module={moduleName} heading={pageHeading} link={HeadQuarterRoute.path} />
      <Backdrop className={classes.backdrop} open={loading}>
        <CommonLoader />
      </Backdrop>
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={9}>
              <Box mt={1} mb={2}>
                <Typography className={classes.pageHeading}> {pageHeading} </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} direction="row">
              <Box textAlign="right" mt={1} mb={1}>
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetForm()}>
                  Reset
                </CommonButton>
                <CommonButton
                  cssClass="customSubmitBtn"
                  isGreen
                  onClick={() => formik.submitForm()}
                >
                  Save
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
          <Box style={{ marginBottom: "10px" }}>
            <Divider />
          </Box>
          <>
            <Grid spacing={2} container direction="column">
              <Grid item xs={12} md={10} xl={8} lg={8}>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <Typography style={{ width: "260px" }}>Camera Stream: </Typography>
                  <TextField
                    className={"customTextField"}
                    InputProps={{ inputProps: { min: 0 } }}
                    type="text"
                    size="small"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="Camera Stream"
                    placeholder="Camera Stream"
                    value={formik.values.cameraFeed}
                    onChange={(e) => formik.setFieldValue("cameraFeed", e.target.value)}
                    error={formik.touched.cameraFeed && Boolean(formik.errors.cameraFeed)}
                    helperText={formik.touched.cameraFeed && formik.errors.cameraFeed}
                  />
                </Box>
              </Grid>
            </Grid>
          </>
        </CardContent>
      </Card>
    </>
  );
}
